export enum ManagedFunctionType {
    DataCopySqlToSqlFunction = 1,
    DataCopySqlToDatalakeFunction = 2,
    DataPurgeSqlFunction = 3
}
